import type { LinkProps } from '@tanstack/react-router';
import { createContext, useContext } from 'react';

import type { InboxSearch } from '../schemas/inbox-search';

/** Where the inbox lives: org-wide, or one store's view with the store filter pinned. */
export interface InboxScope {
  pinnedStoreId?: string | undefined;
  /** The list with the current filters, for "back" and after trashing. */
  listLink: LinkProps;
  threadLink: (conversation: { id: string; storeId: string }) => LinkProps;
}

export function orgInboxScope(search: InboxSearch): InboxScope {
  return {
    listLink: { to: '/org/inbox', search },
    threadLink: (conversation) => ({
      to: '/org/inbox/$storeId/$conversationId',
      params: { storeId: conversation.storeId, conversationId: conversation.id },
      search,
    }),
  };
}

export function storeInboxScope(storeId: string, search: InboxSearch): InboxScope {
  return {
    pinnedStoreId: storeId,
    listLink: { to: '/s/$storeId/inbox', params: { storeId }, search },
    threadLink: (conversation) => ({
      to: '/s/$storeId/inbox/$conversationId',
      params: { storeId, conversationId: conversation.id },
      search,
    }),
  };
}

export const InboxScopeContext = createContext<InboxScope>(orgInboxScope({}));

export function useInboxScope(): InboxScope {
  return useContext(InboxScopeContext);
}
